var _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplorer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5838 44.3424C26.4597 44.3424 31.1676 39.6325 31.1676 33.7586C31.1676 27.8847 26.4597 23.1748 20.5838 23.1748C14.7099 23.1748 10 27.8847 10 33.7586C10 39.6325 14.7099 44.3424 20.5838 44.3424Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5838 16.8424C23.6838 16.8424 26.1676 14.3575 26.1676 11.2586C26.1676 8.15965 23.6838 5.6748 20.5838 5.6748C17.4848 5.6748 15 8.15965 15 11.2586C15 14.3575 17.4848 16.8424 20.5838 16.8424Z",
    fill: "#E5B910"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0838 31.8424C46.1838 31.8424 48.6676 29.3575 48.6676 26.2586C48.6676 23.1597 46.1838 20.6748 43.0838 20.6748C39.9848 20.6748 37.5 23.1597 37.5 26.2586C37.5 29.3575 39.9848 31.8424 43.0838 31.8424Z",
    fill: "#E5B910"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0838 54.3424C41.1838 54.3424 43.6676 51.8575 43.6676 48.7586C43.6676 45.6597 41.1838 43.1748 38.0838 43.1748C34.9848 43.1748 32.5 45.6597 32.5 48.7586C32.5 51.8575 34.9848 54.3424 38.0838 54.3424Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorer1);
export default __webpack_public_path__ + "static/media/explorer1.c12b9409dd2ed00ac4ebe40a0cdf1455.svg";
export { ForwardRef as ReactComponent };